const translations: any = {
  // Messages
  messages: {
    login_required: {
      ar: "من فضلك سجل الدخول مجددا",
      en: "Please login again.",
    },
    error_occurred: {
      ar: "حدث خطا من فضلك حاول مجددا",
      en: "An error has ocurred, please try again.",
    },
    failure_in_sending_request: {
      ar: "حدث خطا أثناء إرسال الطلب!!!",
      en: "Failed to send the request to the server.",
    },
    failure_in_calling_server: {
      ar: "حدث خطا أثناء إرسال الطلب!!!",
      en: "Error in calling the server.",
    },
    upload_image_success: {
      ar: "تم رفع الصورة بنجاح",
      en: "Image uploaded successfully.",
    },
    upload_products_success: {
      ar: "تم تحميل الملف بنجاح. سوف يأتى أشعار لك عند الأنتهاء من الإنشاء من المنتجات",
      en: "File was uploaded successfully. You will get a notification when the products created",
    },
  },

  // General
  general: {
    beta: {
      ar: "بيتا",
      en: "Beta",
    },
    filtered_by_merchant: {
      ar: "تم التصفية بواسطة التاجر",
      en: "Filtered by Merchant",
    },
    clear_filter: {
      ar: "مسح الفلتر",
      en: "Clear Filter",
    },
    view: {
      ar: "عرض",
      en: "View",
    },
    payments_requests: {
      ar: "طلبات الدفع",
      en: "Payment Requests",
    },
    view_more: {
      ar: "عرض المزيد",
      en: "View More",
    },
    payment_requests: {
      ar: "طلبات الدفع",
      en: "Payment Requests",
    },
    promotion_banners: {
      ar: "بانرات الترويج",
      en: "Promotion Banners",
    },
    al_mtger: {
      ar: "المتجر",
      en: "Al Mtger",
    },
    address: {
      ar: "العنوان",
      en: "Address",
    },
    address_line2: {
      ar: "العنوان 2",
      en: "Address Line 2",
    },
    address_line1: {
      ar: "العنوان 1",
      en: "Address Line 1",
    },
    subscriptions: {
      ar: "الاشتراكات",
      en: "Subscriptions",
    },
    currency: {
      ar: "جنيه",
      en: "EGP",
    },
    upload_success: {
      ar: "تم التحميل بنجاح",
      en: "Upload Success",
    },
    upload_change_or_remove: {
      ar: "قم بتغيير الصورة او حذفها",
      en: "Change or Remove Image",
    },
    upload_logo_desc: {
      ar: "اسحب الصورة هنا او اضغط للرفع",
      en: "Drag and drop your image here or click to upload",
    },
    upload_logo_desc_2: {
      ar: "اسحب الصورة هنا او اضغط للرفع",
      en: "Drag and drop your image here or click to upload",
    },
    upload_logo: {
      ar: "رفع الصورة",
      en: "Upload Image",
    },
    change_logo: {
      ar: "تغيير الصورة",
      en: "Change Image",
    },
    remove_logo: {
      ar: "حذف الصورة",
      en: "Remove Image",
    },
    upload_logo_button: {
      ar: "اختر الصورة",
      en: "Choose Image",
    },
    wait_message: {
      ar: "يرجى الانتظار حتى اكتمال التحميل",
      en: "Please wait until the upload is complete",
    },
    email: {
      ar: "البريد الإليكترونى",
      en: "Email",
    },
    yes: {
      ar: "نعم",
      en: "Yes",
    },
    no: {
      ar: "لا",
      en: "No",
    },
    coupons: {
      ar: "الكوبونات",
      en: "Coupons",
    },
    no_coupons: {
      ar: "لا يوجد كوبونات",
      en: "No Coupons",
    },
    phone_number: {
      ar: "رقم المحمول",
      en: "Phone Number",
    },
    shipping_rates: {
      ar: "اسعار الشحن",
      en: "Shipping Rates",
    },
    merchant: {
      ar: "التاجر",
      en: "Merchant",
    },
    checkout: {
      ar: "رابط الدفع",
      en: "Checkout",
    },
    products: {
      ar: "المنتجات",
      en: "Products",
    },
    checkout_links: {
      ar: "روابط الدفع",
      en: "Checkout Links",
    },
    merchants_profiles: {
      ar: "ملفات التاجر",
      en: "Merchants Profiles",
    },
    customers: {
      ar: "العملاء",
      en: "Customers",
    },
    orders: {
      ar: "الطلبات",
      en: "Orders",
    },
    country: {
      ar: "الدولة",
      en: "Country",
    },
    countries: {
      ar: "الدول",
      en: "Countries",
    },
    governorate: {
      ar: "المحافظة",
      en: "Governorate",
    },
    governorates: {
      ar: "المحافظات",
      en: "Governorates",
    },
    city: {
      ar: "المدينة",
      en: "City",
    },
    cities: {
      ar: "المدن",
      en: "Cities",
    },
    address_line_1: {
      ar: "العنوان الأول",
      en: "Address Line 1",
    },
    address_line_2: {
      ar: "العنوان الثانى",
      en: "Address Line 2",
    },
    settings: {
      ar: "الإعدادات",
      en: "settings",
    },
    merchant_column: {
      ar: "المتجر",
      en: "Merchant",
    },
    orders_status: {
      ar: "حالات الطلبات",
      en: "Orders Status",
    },
    custom_geo: {
      ar: "الموقع الجغرافي",
      en: "Custom GEO",
    },
    delete_confirmation: {
      ar: "هل أنت متأكد أنك تريد مسح هذا العنصر",
      en: "Are you sure you want to delete this item",
    },
    custom_attribute_delete_confirmation: {
      ar: "هل أنت متأكد أنك تريد مسح هذا الخاصية",
      en: "Are you sure you want to delete this attribute",
    },
    buttons: {
      upload_image: {
        ar: "رفع",
        en: "Upload",
      },
      search: {
        ar: "إبحث",
        en: "Search",
      },
      loading: {
        ar: "جارى التحميل",
        en: "Loading",
      },
      delete: {
        ar: "مسح",
        en: "Delete",
      },
      refresh: {
        ar: "تحديث",
        en: "Refresh",
      },
      edit: {
        ar: "تعديل",
        en: "Edit",
      },
      update: {
        ar: "تحديث",
        en: "Update",
      },
      change: {
        ar: "تغيير",
        en: "Change",
      },
      create: {
        ar: "إنشاء",
        en: "Create",
      },
      info: {
        ar: "تفاصيل",
        en: "Info",
      },
      send: {
        ar: "إرسال",
        en: "Send",
      },
      add_coupon: {
        ar: "إضافة كوبون",
        en: "Add Coupon",
      },
      close: {
        ar: "إغلاق",
        en: "Close",
      },
      import_products: {
        ar: "إضافة المنتجات",
        en: "Import Products",
      },
      export_orders: {
        ar: "تحميل طلباتك فى ملف إكسل",
        en: "Export you orders into excel",
      },
      export_products: {
        ar: "تحميل منتجاتك فى ملف إكسل",
        en: "Export your products into Excel",
      },
    },
    price: {
      ar: "السعر",
      en: "Price",
    },
    actions: {
      ar: "الإجراءات",
      en: "Actions",
    },
    id_column: {
      ar: "الرقم التعريفى",
      en: "#ID",
    },
    name: {
      ar: "الإسم",
      en: "Name",
    },
    sku_column: {
      ar: "الرمز التعريفى للمنتج",
      en: "SKU",
    },
    sales_price: {
      ar: "سعر البيع للمنتج",
      en: "Sales Price",
    },
    product_deleted: {
      ar: "المنتج غير موجود",
      en: "Product Deleted",
    },
    first_name: {
      ar: "الإسم الاول",
      en: "First Name",
    },
    last_name: {
      ar: "الإسم الثانى",
      en: "Last Name",
    },
    select_country: {
      ar: "اختر الدولة",
      en: "Select Country",
    },
    select_governorate: {
      ar: "اختر المحافظة",
      en: "Select Governorate",
    },
    select_city: {
      ar: "إختر المدينة",
      en: "Select City",
    },
    placeholder: {
      first_name: {
        ar: "ادخل الإسم الأول",
        en: "Enter First Name",
      },
      last_name: {
        ar: "ادخل الإسم الأخير",
        en: "Enter Last Name",
      },
      phone_number: {
        ar: "ادخل رقم التليفون",
        en: "Enter Phone Number",
      },
      email: {
        ar: "ادخل البريد الإليكترونى",
        en: "Enter Email",
      },
      address_line_1: {
        ar: "ادخل العنوان الأول",
        en: "Enter Address Line 1",
      },
      address_line_2: {
        ar: "ادخل العنوان الثانى",
        en: "Enter Address Line 2",
      },
      notes: {
        ar: "ادخل ملاحظاتك",
        en: "Enter your notes",
      },
    },
  },

  // Auth
  auth: {
    login_title: {
      ar: "تسجيل دخول الأدمن | المتجر",
      en: "Admin Login | Al Mtger",
    },
    welcome_back: {
      ar: "مرحبا بعودتك",
      en: "Welcome Back",
    },
    sign_in_to_continue: {
      ar: "سجل دخولك للمتابعة",
      en: "Sign in to continue",
    },

    email_placeholder: {
      ar: "البريد الإلكتروني",
      en: "Email",
    },
    password_placeholder: {
      ar: "كلمة المرور",
      en: "Password",
    },

    slogan: {
      ar: "المتجر",
      en: "Al Mtger",
    },
    main_slogan: {
      ar: "حلك الأفضل للتجارة الإليكترونية",
      en: "Your Best E-Commerce Solution.",
    },
    login_text: {
      ar: "سجل",
      en: "Login.",
    },
    manage_text: {
      ar: "تحكم",
      en: "Manage.",
    },
    start_selling_text: {
      ar: "إبدا البيع",
      en: "Start Selling.",
    },
    succeed_text: {
      ar: "إنجح",
      en: "Succeed.",
    },
    all_rights_reserved: {
      ar: "جميع الحقوق محفوظة للمتجر",
      en: "Al Mtger All Rights Reserved.",
    },

    login_link_text: {
      ar: "سجل دخول",
      en: "Login",
    },
    password: {
      ar: "الرقم السرى",
      en: "Password",
    },
    already_have_account: {
      ar: "لديك حساب؟",
      en: "Already have an account?",
    },
    confirm_password: {
      ar: "تأكيد الرقم السرى",
      en: "Confirm Password",
    },
    messages: {
      password_does_not_match: {
        ar: "الرقم السرى غير مطابق",
        en: "Password not matched.",
      },
    },
  },

  // SideBar
  sidebar: {
    dashboard_link: {
      ar: "الصفحة الرئيسية",
      en: "Dashboard",
    },
    merchants_link: {
      ar: "التجار",
      en: "Merchants",
    },
    products_link: {
      ar: "المنتجات",
      en: "Products",
    },
    logout_link: {
      ar: "تسجيل الخروج",
      en: "Logout",
    },
    greeting_message: {
      ar: "مرحبا",
      en: "Hello",
    },
  },

  // VTable
  vtable: {
    showing: {
      ar: "عرض",
      en: "Showing",
    },
    to: {
      ar: "إلى",
      en: "to",
    },
    of: {
      ar: "من",
      en: "of",
    },
    row: {
      ar: "صفوف",
      en: "row",
    },
    select_shipping_rate_placeholder: {
      ar: "اختر من الأنواع",
      en: "Select from the types",
    },
    search_placeholder: {
      ar: "إبحث...",
      en: "Search....",
    },
    all_word: {
      ar: "الكل",
      en: "All",
    },
    no_data: {
      ar: "لا توجد بيانات متاحة",
      en: "No data available",
    },
  },

  // Dashboard
  dashboard: {
    admin_dashboard: {
      ar: "لوحة التحكم",
      en: "Admin Dashboard",
    },
    checkout_links: {
      ar: "الدفع",
      en: "Checkout",
    },
    merchants: {
      ar: "التجار",
      en: "Merchants",
    },
    database_size: {
      ar: "حجم البيانات",
      en: "Database Size",
    },
    os_storage: {
      ar: "وحدة التخزين",
      en: "OS Storage",
    },
    os_free_storage: {
      ar: "المساحه الخاليه",
      en: "OS Free Storage",
    },
    images_count: {
      ar: "عدد الصور",
      en: "Images Count",
    },
    server_switcher_label: {
      ar: "اختيار السيرفر",
      en: "Server Selection",
    },
    server_switcher_title: {
      ar: "التبديل بين السيرفرات",
      en: "Switch Between Servers",
    },
    media_server: {
      ar: "ميديا سيرفر",
      en: "Media Server",
    },
    media_server_overview: {
      ar: "ملخص الميديا سيرفر",
      en: "Media Server Overview",
    },
    media_server_description: {
      ar: "عرض بيانات التخزين والصور الخاصة بالميديا سيرفر",
      en: "View storage and image statistics from the media server",
    },
    auth_server: {
      ar: "Auth Server",
      en: "Auth Server",
    },
    auth_server_overview: {
      ar: "ملخص auth server",
      en: "Auth Server Overview",
    },
    auth_server_description: {
      ar: "عرض بيانات التخزين والإحصاءات الخاصة بسيرفر التوثيق",
      en: "View storage and system statistics from the auth server",
    },
    server_details: {
      ar: "تفاصيل السيرفر",
      en: "Server Details",
    },
    server_url: {
      ar: "الرابط",
      en: "URL",
    },
    auth_clients: {
      ar: "العملاء",
      en: "Clients",
    },
    auth_tenants: {
      ar: "المؤجرون",
      en: "Tenants",
    },
    auth_users: {
      ar: "المستخدمون",
      en: "Users",
    },
    auth_applications: {
      ar: "التطبيقات",
      en: "Applications",
    },
    auth_server_details: {
      ar: "بيانات السيرفر",
      en: "Server Details",
    },
    auth_servers_count: {
      ar: "عدد السيرفرات",
      en: "Servers",
    },
    admin: {
      ar: "الادمن",
      en: "Admin",
    },
    title: {
      ar: "لوحة التحكم",
      en: "Admin Dashboard",
    },
    filter_by_date: {
      ar: "ابحث بالتاريخ",
      en: "Filter By Date",
    },
    orders: {
      ar: "عدد الطلبات",
      en: "Total Orders",
    },
    cash_on_delivery: {
      ar: "المبالغ المحصلة",
      en: "Cash",
    },
    customers: {
      ar: "عدد العملاء",
      en: "Total Customers",
    },
    products: {
      ar: "عدد المنتجات",
      en: "Total Products",
    },
    live_data: {
      ar: "نشط الآن",
      en: "Live Now",
    },
    refreshing: {
      ar: "جاري التحديث...",
      en: "Refreshing...",
    },
    refresh: {
      ar: "حدث",
      en: "Refresh",
    },
    quick_actions: {
      ar: "إجراءات سريعة",
      en: "Quick Actions",
    },
    new_order: {
      ar: "طلب جديد",
      en: "New Order",
    },
    new_order_desc: {
      ar: "املأ تفاصيل الطلب الجديد أدناه",
      en: "Fill in the details of the new order below",
    },
    new_product: {
      ar: "منتج جديد",
      en: "New Product",
    },
    new_product_desc: {
      ar: "املأ تفاصيل المنتج الجديد أدناه",
      en: "Fill in the details of the new product below",
    },
    business_profile: {
      ar: "الملف التجاري",
      en: "Business Profile",
    },
    business_profile_desc: {
      ar: "قم بتحديث معلومات متجرك من هنا",
      en: "Update your store information from here",
    },
    refresh_success_message: {
      ar: "تم التحديث بنجاح",
      en: "Data refreshed successfully",
    },
  },

  // Merchants
  merchants: {
    title: {
      ar: "التجار",
      en: "Merchants",
    },
    email: {
      ar: "البريد الإليكترونى",
      en: "Email",
    },
    full_name: {
      ar: "الأسم بالكامل",
      en: "Full Name",
    },
    orders_count: {
      ar: "عدد الطلبات",
      en: "Orders Count",
    },
    products_count: {
      ar: "عدد المنتجات",
      en: "Products Count",
    },
    status: {
      ar: "الحالة",
      en: "Status",
    },
    action_status: {
      ar: "حالة العملية",
      en: "Action Status",
    },
    created: {
      ar: "تاريخ الإنشاء",
      en: "Created",
    },
    last_login: {
      ar: "تاريخ أخر تسجيل دخول",
      en: "Last Login",
    },
    buttons: {
      change_status: {
        ar: "تغيير الحالة",
        en: "Change Status",
      },
      features_control: {
        ar: "تحكم في الميزات",
        en: "Features Control",
      },
      access_tabs: {
        ar: "الصلاحيات",
        en: "Access Tabs",
      },
      orders: {
        ar: "الطلبات",
        en: "Orders",
      },
      products: {
        ar: "المنتجات",
        en: "Products",
      },
      profiles: {
        ar: "الملفات الشخصية",
        en: "Profiles",
      },
    },
    modal: {
      update_status: {
        ar: "تحديث الحالة تاجر",
        en: "Update Merchant Status",
      },
      status_change: {
        en: "Choose the new status for this merchant:",
        ar: "اختر الحالة الجديدة للتجر",
      },
      status: {
        en: "Current Status:",
        ar: "الحالة الحالية:",
      },
      status_type: {
        active: {
          en: "Active",
          ar: "نشط",
        },
        suspended: {
          en: "Suspended",
          ar: "معطل",
        },
      },
      status_active: {
        en: "Activate Merchant",
        ar: "تفعيل التجر",
      },
      status_active_desc: {
        en: "Allow merchant to operate normally",
        ar: "السماح للتجر بالعمل بشكل عادى",
      },
      status_suspended: {
        en: "Suspend Merchant",
        ar: "تعطيل التجر",
      },
      status_suspended_desc: {
        en: "Temporarily disable merchant operations",
        ar: "تعطيل التجر موقتا",
      },
      merchant_key: {
        en: "Merchant ",
        ar: " التجر",
      },
    },
    messages: {
      merchant_status_not_updated: {
        en: "Failed to update merchant status",
        ar: "فشل في تحديث حالة التجر",
      },
      merchant_status_updated: {
        en: "Merchant status updated successfully",
        ar: "تم تحديث حالة التجر بنجاح",
      },
    },
  },

  // FeatureContorl
  feature_control: {
    title: {
      ar: "تحكم في الميزات",
      en: "Features Control",
    },
    description: {
      ar: "قم بتحديث وتخصيص الميزات من هنا",
      en: "Manage and customize your application features with ease",
    },
    status: {
      active: {
        ar: "نشط",
        en: "Active",
      },
      inactive: {
        ar: "غير نشط",
        en: "Inactive",
      },
    },
    enabled: {
      ar: "مفعل",
      en: "Enabled",
    },
    disabled: {
      ar: "غير مفعل",
      en: "Disabled",
    },
    messages: {
      feature_control_added: {
        en: "Feature control added successfully",
        ar: "تمت اضافة التحكم في الميزة بنجاح",
      },
      feature_control_not_added: {
        en: "Failed to add feature control",
        ar: "فشل في اضافة التحكم في الميزة",
      },
      feature_control_not_removed: {
        en: "Failed to remove feature control",
        ar: "فشل في حذف التحكم في الميزة",
      },
      feature_control_removed: {
        en: "Feature control removed successfully",
        ar: "تم حذف التحكم في الميزة بنجاح",
      },
    },
  },

  // Access Tabs
  access_tabs: {
    title: {
      ar: "الصلاحيات",
      en: "Access Tabs",
    },
    description: {
      ar: "قم بتحديد الصلاحيات المتاحة لهذا التاجر",
      en: "Manage which tabs this merchant can access",
    },
    status: {
      active: {
        ar: "نشط",
        en: "Active",
      },
      inactive: {
        ar: "غير نشط",
        en: "Inactive",
      },
    },
    enabled: {
      ar: "مفعل",
      en: "Enabled",
    },
    disabled: {
      ar: "غير مفعل",
      en: "Disabled",
    },
    tabs: {
      general: {
        ar: "عام",
        en: "General",
      },
    },
    messages: {
      access_tab_added: {
        en: "Access tab added successfully",
        ar: "تمت إضافة الصلاحية بنجاح",
      },
      access_tab_not_added: {
        en: "Failed to add access tab",
        ar: "فشل في إضافة الصلاحية",
      },
      access_tab_not_removed: {
        en: "Failed to remove access tab",
        ar: "فشل في حذف صلاحية",
      },
      access_tab_removed: {
        en: "Access tab removed successfully",
        ar: "تم حذف صلاحية بنجاح",
      },
    },
  },

  // products
  products: {
    title: {
      ar: "المنتجات",
      en: "Products",
    },
    image_column: {
      ar: "الصورة",
      en: "Image",
    },
  },

  // List Checkout
  list_checkouts: {
    title: {
      ar: "روابط الدفع | المتجر",
      en: "Checkouts | Al Mtger",
    },
    link: {
      ar: "الرابط",
      en: "Link URL",
    },
    click_to_copy: {
      ar: "اضغط للنسخ",
      en: "Click To Copy",
    },
    unlimited_text: {
      ar: "غير محدود",
      en: "UnLimited",
    },
    checkout_url_column: {
      ar: "رابط الدفع",
      en: "Checkout URL",
    },
    description_column: {
      ar: "وصف الرابط",
      en: "Description",
    },
    copied: {
      ar: "تم النسخ",
      en: "Copied",
    },
    active_column: {
      ar: "الحالة",
      en: "Status",
    },
    limit_column: {
      ar: "حدود",
      en: "Limit",
    },
    merchant: {
      ar: "التاجر",
      en: "Merchant",
    },
  },

  // List Orders
  list_orders: {
    title: {
      ar: "الطلبات",
      en: "Orders",
    },
    shipping_customer_name_column: {
      ar: "إسم العميل",
      en: "Customer Name",
    },
    status_column: {
      ar: "حالة الطلب",
      en: "Status",
    },
    created_column: {
      ar: "تاريخ الإنشاء",
      en: "Creation Date",
    },
    items_column: {
      ar: "الأصناف",
      en: "Items",
    },
    subtotal_column: {
      ar: "المجموع",
      en: "Subtotal",
    },
    total_column: {
      ar: "المجموع",
      en: "Total",
    },
  },

  // Order Detail
  order: {
    title: {
      ar: "تفاصيل الطلب",
      en: "Order Detail",
    },
    created: {
      ar: "تم الإنشاء",
      en: "Created",
    },
    customer_information: {
      ar: "معلومات العميل",
      en: "Customer Information",
    },
    full_name: {
      ar: "الإسم بالكامل",
      en: "Full Name",
    },
    first_name: {
      ar: "الإسم الاول",
      en: "First name",
    },
    last_name: {
      ar: "الإسم الثانى",
      en: "Last name",
    },
    email: {
      ar: "البريد الإليكترونى",
      en: "Email",
    },
    phone_number: {
      ar: "رقم المحمول",
      en: "Phone Number",
    },
    total_orders: {
      ar: "إجمالى الطلبات",
      en: "Total Orders",
    },
    total_spend: {
      ar: "إجمالى المبالغ",
      en: "Total Spend",
    },
    blocked_by_email: {
      ar: "⚠️ العميل محظور بواسطة البريد الإليكترونى",
      en: "⚠️ Customer Blocked by Email",
    },
    blocked_by_phone: {
      ar: "⚠️ العميل محظور بواسطة رقم المحمول",
      en: "⚠️ Customer Blocked by Phone Number",
    },
    shipping_address: {
      ar: "عنوان الشحن",
      en: "Shipping Address",
    },
    line_1: {
      ar: "العنوان الأول",
      en: "Line 1",
    },
    line_2: {
      ar: "العنوان الثانى",
      en: "Line 2",
    },
    city: {
      ar: "المدينة",
      en: "City",
    },
    governorate: {
      ar: "المحافظة",
      en: "Governorate",
    },
    country: {
      ar: "الدولة",
      en: "Country",
    },
    products: {
      ar: "المنتجات",
      en: "Products",
    },
    id: {
      ar: "الرقم التعريفى",
      en: "ID",
    },
    name: {
      ar: "الإسم",
      en: "Name",
    },
    quantity: {
      ar: "الكمية",
      en: "Quantity",
    },
    price: {
      ar: "السعر",
      en: "Price",
    },
    sales_price: {
      ar: "سعر البيع",
      en: "Sales Price",
    },
    notes: {
      ar: "ملاحظات",
      en: "Notes",
    },
    tracking_history: {
      ar: "تاريخ التتبع",
      en: "Tracking History",
    },
    tracking_id: {
      ar: "رقم التتبع",
      en: "Tracking ID",
    },
    status: {
      ar: "الحالة",
      en: "Status",
    },
    order_summary: {
      ar: "ملخص الطلب",
      en: "Order Summary",
    },
    subtotal: {
      ar: "المجموع",
      en: "Subtotal",
    },
    discount: {
      ar: "الخصم",
      en: "Discount",
    },
    shipping: {
      ar: "الشحن",
      en: "Shipping",
    },
    vat: {
      ar: "ضريبة القيمة المضافة",
      en: "VAT",
    },
    taxes: {
      ar: "الضرائب",
      en: "Taxes",
    },
    total: {
      ar: "الإجمالى",
      en: "Total",
    },
    coupons: {
      ar: "الكوبونات",
      en: "Coupons",
    },
    shipping_service: {
      ar: "خدمة الشحن",
      en: "Shipping Service",
    },
    tracking_number: {
      ar: "رقم التتبع",
      en: "Tracking Number",
    },
    carrier_name: {
      ar: "إسم الناقل",
      en: "Carrier Name",
    },
    not_assigned: {
      ar: "غير معين",
      en: "Not assigned",
    },
    invoices: {
      ar: "الفواتير",
      en: "Invoices",
    },
    currency: {
      ar: "جنيه",
      en: "EGP",
    },
  },

  // merchants profile
  merchants_profiles: {
    title: {
      ar: "ملف التاجر",
      en: "Merchant Profile",
    },
    logo: {
      ar: "شعار التاجر",
      en: "Merchant Logo",
    },
    business_name: {
      ar: "اسم الشركة",
      en: "Business Name",
    },
    slug: {
      ar: "الرابط",
      en: "Slug",
    },
    view: {
      ar: "عرض",
      en: "View",
    },
  },

  // merchant profile
  merchant_profile: {
    title: {
      ar: "ملف التاجر",
      en: "Merchant Profile",
    },
    subtitle: {
      en: "View detailed merchant information",
      ar: "عرض تفاصيل التاجر",
    },
    id: {
      en: "ID:",
      ar: "الرقم التعريفى:",
    },
    merchant: {
      en: "Merchant",
      ar: "التاجر",
    },
    slug: {
      en: "Slug",
      ar: "الرابط",
    },
    not_set: {
      en: "Not set",
      ar: "غير محدد",
    },
    email: {
      en: "Email",
      ar: "البريد الإليكترونى",
    },
    phone: {
      en: "Phone",
      ar: "رقم المحمول",
    },
    address: {
      en: "Address",
      ar: "العنوان",
    },
    business_description: {
      en: "Business Description",
      ar: "الوصف التجاري",
    },
    social_links: {
      en: "Social Links",
      ar: "روابط التواصل الإجتماعى",
    },
    not_links_available: {
      en: "No social links available",
      ar: "لا توجد روابط تواصل إجتماعى",
    },
    link: {
      en: "Link",
      ar: "الرابط",
    },
    failed_to_load: {
      en: "Failed to load merchant profile",
      ar: "فشل في تحميل ملف التاجر",
    },
  },
  // Subscriptions
  subscription_tab: {
    title: {
      ar: "الاشتراكات",
      en: "Subscriptions",
    },
    id: {
      ar: "المعرف",
      en: "ID",
    },
    invoice_sequence: {
      ar: "رقم الفاتورة",
      en: "Invoice Sequence",
    },
    status: {
      ar: "حالة الفاتورة",
      en: "Invoice Status",
    },
    merchant_name: {
      ar: "اسم التاجر",
      en: "Merchant Name",
    },
    due_date: {
      ar: "تاريخ الاستحقاق",
      en: "Invoice Due Date",
    },
    created_at: {
      ar: "تاريخ الإنشاء",
      en: "Invoice Creation",
    },
    subscription_plan: {
      ar: "خطة الاشتراك",
      en: "Subscription Plan",
    },
    subscription_price: {
      ar: "سعر الاشتراك",
      en: "Subscription Price",
    },
    issued: {
      ar: "صادرة",
      en: "Issued",
    },
    paid: {
      ar: "مدفوعة",
      en: "Paid",
    },
    cancelled: {
      ar: "ملغاة",
      en: "Cancelled",
    },
    pending: {
      ar: "قيد الانتظار",
      en: "Pending",
    },
    all: {
      ar: "الكل",
      en: "All",
    },
    submit_subscription_payment: {
      ar: "تأكيد دفع الاشتراك",
      en: "Submit Subscription Payment",
    },
    subscription_notes: {
      ar: "ملاحظات الاشتراك",
      en: "Subscription Notes",
    },
    subscription_notes_placeholder: {
      ar: "ادخل ملاحظات الاشتراك",
      en: "Enter Subscription Notes",
    },
    payment_type: {
      ar: "نوع الدفع",
      en: "Payment Type",
    },
    payment_image: {
      ar: "صورة الدفع",
      en: "Payment Image",
    },
    total: {
      ar: 'المجموع',
      en: 'Total'
    }
  },

  // Payment Requests
  payment_requests: {
    title: {
      ar: "طلبات الدفع",
      en: "Payment Requests",
    },
    image: {
      ar: "صورة الدفع",
      en: "Payment Image",
    },
    status: {
      ar: "حالة الطلب",
      en: "Request Status",
    },
    notes: {
      ar: "ملاحظات",
      en: "Notes",
    },
    payment_type: {
      ar: "نوع الدفع",
      en: "Payment Type",
    },
    payment_value: {
      ar: "قيمة الدفع",
      en: "Payment Value",
    },
    paid: {
      ar: "مدفوعة",
      en: "Paid",
    },
    cancelled: {
      ar: "ملغاة",
      en: "Cancelled",
    },
    submitted: {
      ar: "مقدمة",
      en: "Submitted",
    },
    all: {
      ar: "الكل",
      en: "All",
    },
    buttons: {
      change_status: {
        ar: "تغيير الحالة",
        en: "Change Status",
      },
    },
    modal: {
      update_status: {
        ar: "تغيير الحالة",
        en: "Change Status",
      },
      status_change: {
        ar: "تغيير الحالة",
        en: "Change Status",
      },
      status_paid: {
        ar: "مدفوعة",
        en: "Paid",
      },
      status_paid_desc: {
        ar: "تم الدفع",
        en: "Paid",
      },
      status_cancelled: {
        ar: "ملغاة",
        en: "Cancelled",
      },
      status_cancelled_desc: {
        ar: "تم الغاء",
        en: "Cancelled",
      },
      mark_paid: {
        ar: "تحديث الحالة",
        en: "Update Status",
      },
      mark_cancelled: {
        ar: "تحديث الحالة",
        en: "Update Status",
      },
    },
  },
}

export const translate = (key: string = "", lang: string = "ar"): any => {
  let currentPart = translations

  for (const part of key.split(".")) {
    if (!(part in currentPart)) {
      return key
    }

    currentPart = currentPart[part]
  }

  if (!(lang in currentPart)) {
    return key
  }

  return currentPart[lang]
}
